import React from 'react'
import "./style.css";
import Eat from './EatCard.js'
import Move from './MoveCard.js'
import Relax from './RelaxCard.js'
import Sleep from './SleepCard.js'


function PillarCard() {
 
 

  return (
  <>
   
    <Eat />
    <Move />
    <Relax />
    <Sleep />
   
    </>
    )

  
}

export default PillarCard